import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import trabajoImg from "../../assets/img/family.png";

const Trabajo = () => {
  return (
    <section className="trabajo-section">
      <Container>
        <Row>
          <Col md={11} xs={10} className="mx-auto">
            <Row className="align-items-center">
              <Col md={6} className="ps-md-5 text-start">
                <h2 className="trabajo-title text-start">Trabaja con nosotros</h2>
                <p className="text-start">
                  Ser parte de MCBrokers, significa poner al cliente en el centro de nuestras acciones y colaborar en
                  equipo en pro de sus requerimientos.
                </p>
                <p className="text-start">¡Potencia tu vocación de servicio con nosotros!</p>
                <p className="text-start pb-md-0 pb-4">¡Conoce nuestras vacantes!</p>

                <Button
                  className="trabajo-btn"
                  href="https://mc-brokers.pandape.computrabajo.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Quiero postularme
                </Button>

                <p className="trabajo-footer">Esperamos verte pronto...</p>
              </Col>
              <Col md={6} className="text-center mt-4 mt-md-0 pt-md-0 pt-4">
                <img src={trabajoImg} alt="Familia MCBrokers" className="img-fluid trabajo-img" />
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Trabajo;
